import React from "react"
import FieldProto from "../proto/field-proto";

export enum FieldPickerType {
    DEFAULT = 'default',
    TEXT    = 'text',
    CIRCLE  = 'circle'
}

export enum FieldPickerSize {
    DEFAULT     = 'default',
    SIZE_30     = '30'
}

export type FieldPickerProps = {
    type?               : FieldPickerType
    size?               : FieldPickerSize
    field               : FieldProto
    model               : any
    disabled?           : boolean
    configOptions?      : any
    onChange?           : func // onChangeCallback
    className?          : string
    options?            : any

    onTogglePopover?    : {(value: boolean): void}
};

export default function FieldPicker(props:FieldPickerProps):any {
    return <props.field.renderComponents.picker {...props} />
}
